package modysy.simulation.pp

/** Contains the output of an population protocol state.
  * This will possibly be expanded later or used for checking
  * convergence of the population protocol.
  *
  * @param name the output
  */
case class Output(name: String) {}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/simulation/pp/Output.scala